// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3qwET","icon":"SortAdornment_icon__26Gre","up":"SortAdornment_up__1aquk","down":"SortAdornment_down__3eHvY","active":"SortAdornment_active__3LbMu"};